export default {
  id : 'ps.ShelfMonitoringEventsQueryHandler',
  matches : {
    objectType : 'segment',
    client : 'ps.ShelfMonitoringEvents'
  },
  handle( cxt ) {

    return {
      where : [
        [ '$type', '=', 'product' ],
        [ '$ack.id', '=', null ]
      ],
      paths : [
        '$id',
        '$deviceId',
        '$blueprintId',
        '$time',
        '$receivedTime',
        '$storedTime',
        '$type',
        '$data',
        '$event.userId',
        '$event.source',
        '$ack.id',
        '$ack.userId',
        '$ack.source',
        '$ack.time',
        [
          '$ack.data',
          'ackData',
          null,
          'object'
        ]
      ],
      ack : true
    }
  }
}
